import React from "react";
import {ExportConfigDto} from "../configuration/ExportConfigDto";
import {FeatureStatusesDto} from "../configuration/FeatureStatusesDto";
import {ModelExportFormatType} from "./apis/Exports";

export interface Configuration {
    featureStatuses: FeatureStatusesDto;
    setFeatureStatuses: (featureStatuses: FeatureStatusesDto) => void;
    exportConfig: ExportConfigDto;
    setExportConfig: (exportConfig: ExportConfigDto) => void;
}

const ConfigurationContext = React.createContext<Configuration>({
    featureStatuses: {
        aiEnabled: false,
        graphQueryEnabled: false,
    },
    setFeatureStatuses: () => {
    },
    exportConfig: {
        exportFormat: ModelExportFormatType.ARCHIMATE_VERSION_3_1,
    },
    setExportConfig: () => {
    },
});

export default ConfigurationContext;
